<template>
  <section class="c-section c-section--contact-specialist py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
          <h2 class="fs-50 fs-md-55 sec-medium w-light text-center mb-3">
            Únete a nuestro equipo de profesionales
          </h2>
          <p class="sec-medium w-light fs-21 text-center mb-5">
            AgroClub es una comunidad especializada en brindar soluciones educativas
            a todo el sector agrícola del mundo. ¿Quieres unirte a nuestro equipo?
            ¡Obtén increíbles beneficios!
          </p>

          <Alert v-if="alert.message" :type="alert.type" :message.sync="alert.message"/>

          <div>
            <div class="row">
              <div class="col-12">
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.contact.fullname.$error }"
                >
                  <input
                    type="text"
                    class="c-form-group__input"
                    v-model.trim="$v.contact.fullname.$model"
                    placeholder="Nombres y Apellidos"
                  />

                  <div class="c-form-group__error" v-if="!$v.contact.fullname.required">
                    Nombres y apellidos requeridos
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.contact.email.$error }"
                >
                  <input
                    type="email"
                    class="c-form-group__input"
                    v-model.trim="$v.contact.email.$model"
                    placeholder="Correo"
                  />

                  <div class="c-form-group__error" v-if="!$v.contact.email.required">
                    Email requerido
                  </div>
                  <div class="c-form-group__error" v-else-if="!$v.contact.email.alpha">
                    El email ingresado es incorrecto
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.contact.phone.$error }"
                >
                  <input
                    type="text"
                    class="c-form-group__input"
                    v-model.trim="$v.contact.phone.$model"
                    placeholder="Celular"
                  />

                  <div class="c-form-group__error" v-if="!$v.contact.phone.required">
                    Celular requerido
                  </div>
                  <div class="c-form-group__error" v-else-if="!$v.contact.phone.alpha">
                    El celular ingresado es incorrecto
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.contact.speciality.$error }"
                >
                  <input
                    type="text"
                    class="c-form-group__input"
                    v-model.trim="$v.contact.speciality.$model"
                    placeholder="Especialidad"
                  />

                  <div class="c-form-group__error" v-if="!$v.contact.speciality.required">
                    Especialidad requerida
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.contact.cv.$error }"
                >
                  <label
                    for="adjuntar-cv"
                    class="c-form-group__file"
                    :class="{'loading' : contact.cv}"
                  >
                    {{attachmentName}}
                  </label>
                  <input
                    @change="attachmentFileChanged($event)"
                    type="file"
                    id="adjuntar-cv"
                    class="d-none"
                    accept=".pdf,.docx"
                  >

                  <div class="c-form-group__error" v-if="!$v.contact.cv.required">
                    Curriculum requerido
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <button
                @click="sendContact()"
                class="c-button c-button--primary px-5"
                :class="{'loading' : contact.isLoading}"
                :disabled="contact.isLoading"
              >
                Enviar
                <span class="c-button__spinner ms-2">
                  <Icon icon="eos-icons:loading" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  required,
  helpers,
  requiredIf,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      recaptcha: '',

      contact: {
        isLoading: false,

        fullname: '',
        email: '',
        phone: '',
        speciality: '',
        cv: '',
      },
      alert: {
        type: '',
        message: '',
      },
    };
  },
  validations: {
    contact: {
      fullname: {
        required,
      },
      email: {
        required,
        alpha: helpers.regex('alpha', /.+@.+\..+/),
      },
      phone: {
        required,
        alpha: helpers.regex('alpha', /^[0-9()+\- ]*$/),
      },
      speciality: {
        required,
      },
      cv: {
        file: {
          required: requiredIf(function file() {
            return this.contact.cv.length === 0;
          }),
        },
      },
    },
  },
  computed: {
    attachmentName() {
      let extension = '';
      let name = '';

      if (this.contact.cv) {
        extension = this.contact.cv.name.split('.');
        extension = extension[extension.length - 1];

        if (this.contact.cv.name.length > 15) {
          name = this.contact.cv.name
            .substring(0, 15);

          name = `${name}....${extension}`;
        } else {
          name = this.contact.cv.name;
        }
      }

      return (!this.contact.cv)
        ? '+ Ajuntar CV (.pdf o .docx)'
        : name;
    },
  },
  components: {
    Alert: () => import(/* webpackChunkName: "ui-alert" */'../../components/ui/Alert.vue'),
  },
  watch: {
    contextLoading(value) {
      if (!value) {
        this.loadScripts();
      }
    },
  },
  created() {
    this.getPageContact();
  },
  methods: {
    attachmentFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        this.contact.cv = '';

        return;
      }

      [this.contact.cv] = files;
    },

    getPageContact() {
      const request = `${process.env.VUE_APP_API}/pages/contact/credentials`;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.recaptcha = response.data.recaptcha_site_key;

            this.loadScripts();
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    sendContact() {
      /* eslint-disable */
      this.$v.$touch();

      if (!this.$v.$invalid) {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.recaptcha)
            .then((token) => {
              const request = `${process.env.VUE_APP_API}/pages/specialist-contact/forms`;
              const formData = new FormData();

              formData.append('email', this.contact.email);
              formData.append('fullname', this.contact.fullname);
              formData.append('curriculumFile', this.contact.cv);
              formData.append('body', JSON.stringify({
                phone: this.contact.phone,
                speciality: this.contact.speciality,
              }));
              formData.append('g-recaptcha-response', token);

              this.contact.isLoading = true;

              fetch(request, {
                method: 'POST',
                body: formData,
              })
                .then((res) => {
                  if (res.status === 201 || res.status < 300) {
                    return res.json();
                  }

                  return res.text().then((text) => { throw new Error(text); });
                })
                .then((response) => {
                  if (response.status) {
                    this.alert = {
                      type: 'success',
                      message: '¡Información enviada exitosamente!, Nos pondremos en contacto contigo pronto.',
                    };

                    this.resetForm();
                  } else {
                    this.alert = {
                      type: 'danger',
                      message: response.message,
                    };
                  }
                })
                .catch((error) => {
                  let errorMessage = '';

                  try {
                    errorMessage = JSON.parse(error.message)?.message;
                  } catch (err) {
                    errorMessage = error.message;
                  }

                  this.alert = {
                    type: 'danger',
                    message: errorMessage,
                  };
                })
                .finally(() => {
                  this.contact.isLoading = false;
                });
            })
            .catch(() => {
              this.alert = {
                type: 'danger',
                message: 'Error con el reCAPTCHA (revisar configuración)',
              };
            });
        });
      }
      /* eslint-enable */
    },
    resetForm() {
      this.$v.contact.$reset();

      this.contact = {
        ...this.contact,

        fullname: '',
        email: '',
        phone: '',
        speciality: '',
        cv: '',
      };
    },

    loadScripts() {
      const recaptchaScript = document.createElement('script');

      recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${this.recaptcha}`);

      document.head.appendChild(recaptchaScript);
    },
  },
};
</script>
